import React, { useEffect } from 'react';
import { ObjectsPopupSelector } from 'components/common';
import { inject } from 'mobx-react';
import { EDITOR_ITEMS_HANDLER_STORE, popupSelectorTypes } from 'store';
import { observer } from 'mobx-react-lite';
import { AddRemoveItemsHandlerProps } from './types';
import { getTitle } from './utils';

const AddRemoveItemsHandler = (props: AddRemoveItemsHandlerProps) => {
  const {
    popupSelector,
    onClose,
    [EDITOR_ITEMS_HANDLER_STORE]: {
      dropdownOnSelect,
      objectList,
      selectedObjectsList,
      onProductListChange,
      submitEntitiesChange,
      clearStoreObservables,
      setPopupSelector,
      dropdownSettings
    }
  } = props;

  useEffect(() => setPopupSelector(popupSelector),
    [setPopupSelector, popupSelector]);

  const handleClose = () => {
    clearStoreObservables();
    onClose();
  };

  switch (popupSelector) {
    case popupSelectorTypes.addProduct:
    case popupSelectorTypes.addPerson:
      return (
        <ObjectsPopupSelector
          title={getTitle(popupSelector)}
          onClose={handleClose}
          dropdownFilterOptions={dropdownSettings.options}
          dropdownLabel={dropdownSettings.label}
          dropdownPlaceholder={dropdownSettings.placeholder}
          dropdownOnSelect={dropdownOnSelect}
          objectsList={objectList}
          selectedObjectsList={selectedObjectsList}
          setSelectedList={onProductListChange}
          submitButtonLabel='SAVE'
          onSubmit={submitEntitiesChange}
        />
      );

    default: return null;
  }
};

export default inject(EDITOR_ITEMS_HANDLER_STORE)(observer(AddRemoveItemsHandler));
